import styled from 'styled-components';
const percentageSize = 1.3;

export const CapaContainer = styled.div`
  padding-top: 7px;
  padding-right: 5px;
  padding-left: 5px;
`;

export const CapaWrapper = styled.div``;

export const HeaderBtn = styled.button`
  border: 0px;
  height: ${({ expanded, length }) => (expanded && length > 35 ? '25px' : 'none')};
  padding-left: 6px;
  padding-right: 10px;
  background-color: transparent;
  align-items: flex-start;
  justify-content: center;
  pointer-events: visible;

  @media screen and (max-width: 464px) {
    padding-top: ${({ expanded, length }) => (expanded && length < 35 ? 'none' : expanded ? '11px' : 'none')};
  }
`;

export const DetailsBody = styled.div`
  background-color: transparent;
  color: #fff;
  /* display: flex;
  flex-direction: row;
  justify-content: start; */
`;

export const ElementsCapa = styled.div`
  padding: 0px;
`;

export const ElementsCapaList = styled.ul`
  padding: 0px;
  padding-bottom: 5px;
  margin: 0;
  padding-left: 20px;
`;

export const ListElement = styled.li`
  display: flex;
  margin-bottom: 5px;
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 12 * percentageSize : 12)}px;
  flex-direction: column;
`;

export const RepresentacioGrafica = styled.div`
  width: 1.5em;
  height: 1.5em;
  background-color: pink;
  border: 0.5px solid #333333;
`;

export const NomRepresentacio = styled.span`
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 12 * percentageSize : 12)}px;
  padding-left: 5px;
  padding-right: 5px;
  display: flex;
  align-items: center;

  @media screen and (max-width: 768px) {
    font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 11 * percentageSize : 11)}px;
  }
`;

export const HeaderDescription = styled.div`
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 12 * percentageSize : 12)}px;
  margin-left: 25px;
  margin-bottom: 8px;
  margin-top: 5px;
`;

export const HeaderInfo = styled.div`
  display: block;
`;

export const HeaderTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 16 * percentageSize : 16)}px;
`;

export const HeaderTitle = styled.div`
  padding-top: ${({ expanded, length }) => (expanded && length < 35 ? '3px' : expanded ? '4px' : '2px')};
  text-overflow: ellipsis;
  white-space: ${({ expanded }) => (expanded ? 'none' : 'nowrap')};
  overflow: hidden;
  width: 250px;
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 14 * percentageSize : 14)}px;

  @media screen and (max-width: 464px) {
    padding-top: ${({ expanded, length }) => (expanded && length < 35 ? '3px' : expanded ? '14px' : '2px')};
  }
  @media screen and (max-width: 390px) {
    width: 210px;
  }
`;

export const ColorWrapper = styled.div`
  width: 25px;
  display: flex;
  margin-top: ${({ expanded, length }) => (expanded && length < 35 ? 'none' : expanded ? '5px' : 'none')};
  @media screen and (max-width: 464px) {
    margin-top: ${({ expanded, length }) => (expanded && length < 35 ? 'none' : expanded ? '15px' : 'none')};
  }
`;
export const RepWrapper = styled.div`
  display: ${({ expanded }) => (expanded ? 'block' : 'flex')};
  align-items: center;
  width: 25px;
  margin-top: ${({ expanded, length }) => (expanded ? (length > 35 ? '3px' : '5px') : 'none')};
  @media screen and (max-width: 464px) {
    padding-top: ${({ expanded, length }) => (expanded && length < 35 ? '2px' : expanded ? '11px' : '2px')};
  }
`;
